import type { ReactNode } from 'react';

/**
 * Direction-neutral: styled against the semantic tokens, so it reads as The Ledger in
 * admin-web and as The Rail in room-web without knowing which it is in. The figure uses
 * --font-figure, which each direction owns — Cascadia Mono in A, the condensed display
 * face at a heavy weight in C.
 */
export function StatCard({ label, value, hint }: { label: string; value: ReactNode; hint?: string }) {
  return (
    <div
      className="border border-line bg-surface p-4"
      style={{ borderTopWidth: 'var(--panel-rule)', borderTopColor: 'var(--color-ink-950)' }}
    >
      <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-ink-800">
        {label}
      </div>
      <div className="num mt-1.5 font-figure text-2xl font-bold leading-none text-ink-950">
        {value}
      </div>
      {hint ? <div className="mt-1.5 text-xs text-ink-800">{hint}</div> : null}
    </div>
  );
}
